import { TablePermission } from "./table-permission";

export class TablePermissionListing{
    public admin: boolean = false;
    public dataSets: TablePermission[];
}